import type { OfertaGasModel } from "@api/api";

export class DatosOfertaGas implements OfertaGasModel {
    TerminoFijo: number = 0;
    TerminoVariable: number = 0;
}